// src/api/endpoints/approvalOrders.js

import { rootApi } from "../rootApi";

export const approvalOrdersApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({

    getApprovalOrders: builder.query({
      query: (params) => ({
        url: "v1/order/approval-orders",
        method: "GET",
        params, 
      }),
      providesTags: ["ApprovalOrders"],
    }),

    getApprovalOrderDetails: builder.query({
      query: (orderId) => ({
        url: `v1/order/approval-order-details/${orderId}`,
        method: "GET",
      }),
    }),

    updateProductQuantity: builder.mutation({
      query: (payload) => ({
        url: "v1/order/update-approval-order-quantity",
        method: "POST",
        body: payload, 
        headers: { "Content-Type": "application/json" },
      }),
      invalidatesTags: ["ApprovalOrders"],
    }),

    removeProduct: builder.mutation({
      query: (payload) => ({
        url: "v1/order/remove-approval-order-product",
        method: "DELETE",
        body: payload,
      }),
      invalidatesTags: ["ApprovalOrders"],
    }),

    approveOrRejectOrder: builder.mutation({
      query: (payload) => ({
        url: "v1/order/approve-reject-order",
        method: "POST",
        body: payload,
        headers: { "Content-Type": "application/json" },
      }),
      invalidatesTags: ["ApprovalOrders"],
    }),
  }),
});

export const {
  useGetApprovalOrdersQuery,
  useLazyGetApprovalOrdersQuery,
  useGetApprovalOrderDetailsQuery,
  useLazyGetApprovalOrderDetailsQuery,
  useUpdateProductQuantityMutation,
  useRemoveProductMutation,
  useApproveOrRejectOrderMutation,
} = approvalOrdersApi;
